module.exports = __webpack_public_path__ + "img/17.7d75e240.jpg";